<template>
  <div class="">
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh" ref="resize">
      <div v-if="orderList.length >= 1">
        <van-list
          v-model="loading"
          :finished="finished"
          :immediate-check="false"
          finished-text="没有更多了"
          @load="onLoad"
          offset="100"
        >
          <div
            class="order"
            v-for="(item, index) in orderList"
            :key="index"
            @click.stop="
              toOptionOrder({
                orderCode: item.record_code,
                orderStatus: item.order_status,
                serveiceId: item.service_id,
                statusName: item.order_status,
                recordDetailId: item.record_detail_id,
              })
            "
          >
            <div>
              <div class="orderTop">
                <p>
                  订单号：{{ item.record_code
                  }}<span>{{ item.orderStatusStr }}</span>
                </p>
              </div>
              <div
                class="orderConent"
                v-for="(order, index) in item.detailList"
                :key="index"
              >
                <div>
                  <img :src="order.color_img" alt="" />
                </div>
                <div class="info">
                  <span class="p1">{{ order.goods_detail_name }}</span>
                  <p class="p2">
                    <span>{{ order.color_name }}</span
                    >x{{ order.num }}
                  </p>
                  <p class="p3">
                    <span>七天无理由退款</span>￥{{ order.price }}元
                  </p>
                </div>
              </div>
              <div class="refundInfo">
                <p>
                  共{{ item.countNum }}件商品，合计<span>¥{{ item.money }}</span
                  >元
                </p>
              </div>
              <!-- 按钮 -->
              <div class="btn">
                <!-- 取消按钮 -->
                <button
                  v-if="item.order_status == '待付款' || item.order_status == 0"
                  type="default"
                  @click.stop="toCancelPayment(item.record_code)"
                >
                  取消
                </button>
                <!-- 申请退款按钮 -->
                <button
                  v-if="item.order_status == '待发货' || item.order_status == 1"
                  type="default"
                  @click.stop="toPayMoney(item.record_code)"
                >
                  取消订单
                </button>
                <!-- 查看物流按钮 -->
                <button
                  v-if="item.order_status == '待收货' || item.order_status == 3"
                  type="default"
                  @click.stop="
                    $router.push({
                      path: '/Logistics',
                      query: { orderCode: item.record_code },
                    })
                  "
                >
                  查看物流
                </button>
                <!-- 评价晒单按钮 -->
                <button
                  v-if="
                    item.order_status == '已完成' &&
                      item.detailList.length == 1 &&
                      item.order_comment_status == false
                  "
                  @click.stop="
                    $router.push({
                      path: '/serviceEvaluation',
                      query: {
                        orderCode: item.record_code,
                        img: item.detailList[0].color_img,
                        id: item.detailList[0].id,
                        record_detail_id: item.detailList[0].record_detail_id,
                      },
                    })
                  "
                  type="default"
                >
                  评价晒单
                </button>
                <button
                  v-else-if="
                    item.order_status == '已完成' &&
                      item.order_comment_status == false
                  "
                  @click.stop="
                    $router.push({
                      path: '/evaluationCenter',
                    })
                  "
                  type="default"
                >
                  评价晒单
                </button>
                <!-- <button disabled="disabled" v-if="item.order_comment_status==true">
                  已评价
                </button> -->
                <!-- 再次购买按钮 -->
                <button
                  v-if="
                    item.order_status == '已完成' ||
                      item.order_status == '已取消' ||
                      item.order_status == '售后完成' ||
                      item.order_status == '退款完成'
                  "
                  type="default"
                  style="color:red; border: 1px solid red;"
                  @click.stop="toBuyCart2(item)"
                >
                  再次购买
                </button>
                <!-- 确认收货按钮 -->
                <button
                  v-if="item.order_status == '待收货' || item.order_status == 3"
                  @click.stop="confirmReceipt(item.record_code)"
                  type="default"
                  style="color:red; border: 1px solid red;"
                >
                  确认收货
                </button>
                <!-- 去支付按钮 -->
                <button
                  v-if="item.order_status == '待付款' || item.order_status == 0"
                  @click.stop="toPayment(item.record_code)"
                  type="default"
                  style="color:red; border: 1px solid red;"
                >
                  去支付
                </button>
                <!-- 售后中 -->
                <div v-if="item.saleService[0]">
                  <button
                    v-if="
                      (item.saleService[0].status == '1' ||
                        item.order_status == 0 ||
                        item.saleService[0].status == '2' ||
                        item.saleService[0].status == '3') &&
                        item.saleService[0].status != 5 &&
                          item.saleService[0].status != 11
                    "
                    @click.stop="onClick(item.service_id)"
                    type="default"
                    style="color:red; border: 1px solid red;"
                  >
                    撤销申请
                  </button>
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </div>
      <!-- 列表为空 -->
      <div v-else class="imgBox" style="min-height: 100vh;">
        <img src="../../assets/img/组 7417@2x.png" alt="" />
      </div>
    </van-pull-refresh>
  </div>
</template>

<script>
import { Toast } from "vant";
import { Dialog } from "vant";
export default {
  name: "allOrders",
  data() {
    return {
      orderList: [], //列表
      loading: false, //是否处在加载状态
      finished: false, //是否已加载完成
      pageSize: 10, //每页的条数
      pageNo: 1, //分页
      totalNum: 0, //数据总条数
      getsum: "",
      isLoading: false,
    };
  },
  props: ["active"],
  created() {
    this.getMyOrder();
  },
  methods: {
    // 加载数据
    getMyOrder() {
      this.$post({
        url: "/oor/findOmsOrderRecordInfo",
        method: "post",
        params: {
          userId: sessionStorage.getItem("EXCLUSIVE"),
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          status: this.active.toString(),
        },
      }).then((res) => {
        if (res.retCode == 200) {
          res.data.code.map((item) => {
            if (item.order_status == 0) {
              item.order_status = "待付款";
            } else if (item.order_status == 1) {
              item.order_status = "待发货";
            } else if (item.order_status == 3) {
              item.order_status = "待收货";
            } else if (item.order_status == 5) {
              item.order_status = "已完成";
            } else if (item.order_status == 7) {
              item.order_status = "已取消";
            } else if (item.order_status == 8) {
              item.order_status = "售后中";
            } else if (item.order_status == 9) {
              item.order_status = "售后完成";
            } else if (item.order_status == 10) {
              item.order_status = "退款中";
            } else if (item.order_status == 11) {
              item.order_status = "退款完成";
            }
          });
        }
        // 总条数
        this.totalNum = res.data.count;
        // this.orderList.push(...res.data.code);
        if (this.pageNo === 1) {
          this.orderList = res.data.code;
        } else {
          this.orderList = this.orderList.concat(res.data.code);
        }
        //每一次加载完设置false，便于下次继续加载
        this.loading = false;
        //判断是否还有数据加载
        if (this.orderList.length >= this.totalNum) {
          this.finished = true; //结束加载状态
        } else {
          // ++this.pageNo;
        }
      });
    },
    //下拉加载
    onLoad() {
      this.pageNo++;
      this.getMyOrder();
    },
    // 下拉刷新
    onRefresh() {
      this.pageNo = 1;
      this.getMyOrder();
      this.isLoading = false;
    },
    // 商品跳转到详细页面
    toOptionOrder(code) {
      if (code.orderStatus == "待发货") {
        this.$router.push({
          path: "/DeliverGoods",
          query: { orderCode: code.orderCode, statusName: code.statusName },
        });
      } else if (code.orderStatus == "待收货") {
        this.$router.push({
          path: "/ConfirmReceivingGoods",
          query: { orderCode: code.orderCode },
        });
      } else if (code.orderStatus == "售后中" || code.orderStatus == "退款中") {
        this.$router.push({
          path: "/returnAudit",
          query: {
            service_code: code.serveiceId,
            orderCode: code.orderCode,
          },
        });
      } else if (code.orderStatus == "已取消") {
        this.$router.push({
          path: "/DeliverGoods",
          query: {
            orderCode: code.orderCode,
            statusName: code.statusName,
          },
        });
      } else if (
        code.orderStatus == "已完成" ||
        code.orderStatus == "退款完成" ||
        code.orderStatus == "售后完成"
      ) {
        this.$router.push({
          path: "/ReceivingGoods",
          query: {
            orderCode: code.orderCode,
            recordDetailId: code.recordDetailId,
          },
        });
      } else if (code.orderStatus == "待付款") {
        this.$router.push({
          path: "/OrderToBePaid",
          query: {
            orderCode: code.orderCode,
            statusName: code.statusName,
          },
        });
      }
    },
    // 取消按钮
    toCancelPayment(recordCode) {
      this.$dialog
        .confirm({
          title: "取消订单",
          message: "您确认要取消订单吗？",
        })
        .then(() => {
          // on confirm
          this.$post({
            url: "/oor/shutOrder",
            method: "post",
            params: {
              recordCode,
            },
          })
            .then((res) => {
              if (res.retCode == 200) {
                this.$toast("已取消");
                this.$nextTick(function() {
                  this.orderList = [];
                });
                this.getMyOrder();
              }
            })
            .catch((err) => {});
        })
        .catch(() => {});
    },
    // 申请退款按钮
    async toPayMoney(orderCode) {
      this.LoadingShow = true;
      this.show = true;
      this.$dialog
        .confirm(
          await {
            title: "提示",
            message: "您确定要取消订单吗？",
          }
        )
        .then(() => {
          this.$post({
            url: "/saleService/apply",
            method: "post",
            headers: {
              "Content-Type": "application/json;charset=utf-8",
            },
            data: {
              userId: sessionStorage.getItem("EXCLUSIVE"),
              recordCode: orderCode,
              serviceMode: "退款",
            },
          })
            .then((res) => {
              if (res.retCode == 200) {
                this.$nextTick(function() {
                  this.orderList = [];
                });
                this.getMyOrder();
                this.$toast("提交成功！待商家审核");
              } else {
                this.LoadingShow = false;
                this.show = false;
                this.$toast(res.message);
              }
            })
            .catch((err) => {
              this.LoadingShow = false;
              this.show = false;
              this.$toast(err.message);
            });
        })
        .catch(() => {
          this.LoadingShow = false;
          this.show = false;
          // on cancel
        });
    },
    // 加入购物车按钮
    async toBuyCart2(item) {
      if (item.detailList[0].goodsStatus == 1) {
        sessionStorage.setItem("P_ID", item.detailList[0].goods_id);
        this.$router.push({ path: "/toShopping" });
      } else {
        this.$toast("该商品已下架！");
      }
    },
    // 确认收货按钮
    async confirmReceipt(code) {
      this.$dialog
        .confirm(
          await {
            title: "提示",
            message: "请确认是否收到货物",
            confirmButtonColor: "#F74B2E",
          }
        )
        .then(() => {
          this.$post({
            url: "oor/confirmRecord",
            method: "get",
            params: {
              recordCode: code,
              status: 5,
            },
          })
            .then((res) => {
              if (res.retCode == 200) {
                this.$toast("已确认收货！");
                this.$nextTick(function() {
                  this.orderList = [];
                });
                this.getMyOrder();
              } else {
                this.$toast("加载失败");
              }
            })
            .catch((err) => {
              this.$toast("加载失败");
            });
        })
        .catch(() => {
          // on cancel
        });
    },
    // 去支付按钮
    async toPayment(code) {
      await this.$post({
        url: "oor/findOrderDetailByOrderCode",
        method: "get",
        params: {
          orderCode: code,
        },
      })
        .then((res) => {
          let flag = true;
          res.data.orderDetail.forEach((item) => {
            if (item.goodsStatus != 1) {
              return (flag = false);
            }
          });
          if (flag) {
            sessionStorage.setItem("PRODUCT_NUMBER", res.data.record_code);
            this.$router.push({
              path: "/payment",
              query: {
                m: res.data.money,
              },
            });
          } else {
            this.$toast("商品已下架");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 撤销申请按钮
    onClick(item) {
      Dialog.confirm({
        title: "撤销申请",
        message:
          "您将撤销本次申请，如您修改退货方式或退货商品，撤销申请后可重新发起申请，确认继续吗？",
      })
        .then(() => {
          this.$post({
            url: "/saleService/cancellation",
            method: "post",
            params: {
              service_id: item,
            },
          })
            .then((res) => {
              if (res.retCode == 200) {
                this.$nextTick(function() {
                  this.orderList = [];
                });
                this.getMyOrder();
                this.$toast("已取消");
              } else {
                this.$toast(res.message);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="less" scoped>
.order {
  margin: 0.266667rem 0.373333rem;
  background-color: white;
  box-sizing: border-box;
  .orderTop {
    border-bottom: 0.026667rem solid #eeeeee;
    p {
      display: flex;
      padding: 0.373333rem 0.4rem;
      box-sizing: border-box;
      justify-content: space-between;
      font-size: 0.373333rem;
      font-weight: 400;
      span {
        color: #f74b2e;
      }
    }
  }
  .orderConent {
    display: flex;
    align-items: center;
    img {
      width: 2.053333rem;
      height: 1.4667rem;
      padding: 0.453333rem;
      object-fit: cover;
    }
    .info {
      // overflow: hidden;
      p {
        width: 6rem;
        display: flex;
        padding-bottom: 0.186667rem;
        justify-content: space-between;
      }
      .p1 {
        color: #333333;
        font-weight: 500;
        font-size: 0.3733rem;
        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
      .p2 {
        margin-top: 0.186667rem;
        font-weight: 400;
        color: #666666;
        font-size: 0.32rem;
      }
      .p3 {
        font-size: 0.373333rem;
        color: #333333;
        font-weight: 500;
        font-size: 0.373333rem;
        span {
          color: #f74b2e;
          font-weight: 400;
          font-size: 0.32rem;
        }
      }
    }
  }
  .refundInfo {
    display: flex;
    justify-content: flex-end;
    padding: 0 0.4rem 0.426667rem 0;
    p {
      font-size: 0.373333rem;
      color: #666666;
      span {
        font-size: 0.373333rem;
        font-weight: 500;
        color: #333333;
      }
    }
  }
  .btn {
    display: flex;
    justify-content: flex-end;
    padding: 0 0.4rem 0.426667rem 0;
    button {
      margin-left: 0.266667rem;
      font-size: 0.32rem;
      padding: 0.133333rem 0.293333rem;
      background: #ffffff;
      color: #333333;
      border: 0.026667rem solid #999999;
      opacity: 1;
      border-radius: 0.373333rem;
    }
  }
}
/deep/.van-list {
  min-height: 100vh;
}
.imgBox {
  img {
    width: 6.5rem;
    height: 5.5rem;
    margin: 3rem auto;
    display: block;
  }
}
</style>
